import type { SettingsTranslations } from "../interfaces/settings";

export const settingsTranslations: SettingsTranslations = {
  title_page: "Configurações",
  language_label: "Idioma",
  general_settings_title: "Geral",
  domain_settings_title: "Domínio",
  integrations_settings_title: "Integrações",

  // Page-level
  settings_eyebrow_account: "Conta",
  settings_subtitle: "Tema, idioma e segurança da sua conta Coloca payments",
  settings_nav_on_this_page: "Nesta página",
  settings_group_preferences: "Preferências",
  settings_group_security: "Segurança",
  settings_group_developers: "Desenvolvedores",
  settings_group_alerts: "Avisos",
  settings_group_account: "Conta",

  // Seções
  appearance_section_title: "Aparência",
  appearance_section_description: "Personalize a interface da aplicação",
  language_section_title: "Idioma e região",
  language_section_description: "Defina o idioma da interface e o fuso horário usado nos seus relatórios.",
  security_section_title: "Segurança",
  security_section_description: "Proteja sua conta com autenticação de dois fatores",

  // Dispositivos
  devices_section_title: "Sessões ativas",
  devices_section_eyebrow: "Dispositivos",
  devices_section_subtitle: "Lista de dispositivos onde sua conta está conectada.",
  devices_badge_current: "ATUAL",
  devices_action_revoke: "Encerrar sessão",
  devices_action_revoke_others: "Encerrar todas as outras sessões",
  devices_confirm_revoke_title: "Encerrar esta sessão?",
  devices_confirm_revoke_body:
    "{{device}} perderá o acesso imediatamente. Será preciso entrar novamente desse dispositivo.",
  devices_confirm_revoke: "Encerrar sessão",
  devices_confirm_revoke_others_title: "Encerrar todas as outras sessões?",
  devices_confirm_revoke_others_body:
    "Você encerrará {{n}} sessão(ões) em outros dispositivos. Sua sessão atual não será afetada.",
  devices_confirm_revoke_others: "Encerrar as outras",
  devices_confirm_cancel: "Cancelar",
  devices_last_seen_now: "Agora",
  devices_last_seen_minutes: "Há {{n}} min",
  devices_last_seen_hours: "Há {{n}} h",
  devices_last_seen_days: "Há {{n}} dias",
  devices_revoke_success: "Sessão encerrada",
  devices_revoke_others_success: "{{n}} sessão(ões) encerradas",
  devices_revoke_error: "Não foi possível encerrar a sessão. Tente novamente.",

  // Aparência
  theme_label: "Tema",
  theme_light: "Claro",
  theme_dark: "Escuro",
  appearance_theme_card_title: "Tema da aplicação",
  appearance_theme_card_sub:
    "Afeta cores de fundo, texto e superfícies. O modo Sistema segue a preferência do dispositivo.",
  appearance_theme_light_hint: "Melhor para luz natural",
  appearance_theme_dark_hint: "Reduz a fadiga visual",
  appearance_theme_system_label: "Sistema",
  appearance_theme_system_hint: "Segue o sistema operacional",

  // Idioma e região
  language_eyebrow: "Localização",
  language_interface_label: "Idioma da interface",
  language_interface_hint: "Aplica-se a menus, mensagens e comprovantes.",
  language_timezone_label: "Fuso horário",
  language_timezone_hint: "Usado no histórico, relatórios e notificações agendadas. Salvo no seu perfil.",
  language_timezone_save_success: "Fuso horário atualizado",
  language_country_label: "País",
  language_country_hint: "País da conta.",
  language_country_save_success: "País atualizado",
  language_country_placeholder: "Selecione um país",
  language_country_search_placeholder: "Buscar país…",
  language_country_no_results: "Sem resultados",

  // Segurança - 2FA
  twofa_status_enabled: "ATIVADO",
  twofa_status_disabled: "DESATIVADO",
  twofa_enable_button: "Ativar",
  twofa_disable_button: "Desativar",
  twofa_description: "Autenticação de dois fatores",
  security_2fa_title: "Verificação em duas etapas (2FA)",
  security_2fa_sub:
    "Solicitada em cada login e ao confirmar transferências acima do limite definido pela sua organização.",
  security_2fa_status_not_configured: "SEM CONFIGURAR",
  security_2fa_protected_title: "Sua conta está protegida com 2FA",
  security_2fa_protected_sub: "Método principal: aplicativo autenticador (TOTP).",
  security_2fa_unprotected_title: "Sua conta não tem 2FA",
  security_2fa_unprotected_sub: "Configure-a para cumprir a política de segurança da sua organização.",
  security_2fa_pick_method: "Escolha um método principal",
  security_method_totp_name: "Aplicativo autenticador",
  security_method_totp_sub: "Google Authenticator, 1Password, Authy…",
  security_method_email_name: "E-mail",
  security_method_email_sub: "Receba um código de 6 dígitos no seu e-mail registrado.",
  security_method_tag_recommended: "RECOMENDADO",
  security_method_tag_coming_soon: "EM BREVE",
  security_2fa_totp_setup_title: "Vincular aplicativo autenticador",
  security_2fa_totp_step: "PASSO {{step}} DE {{total}}",
  security_2fa_code_valid_30s: "o código muda a cada 30 s",
  security_hide: "Ocultar",
  security_show: "Mostrar",
  security_recovery_title: "Códigos de recuperação",
  security_recovery_sub:
    "Guarde-os em local seguro. Cada código pode ser usado uma vez se você perder o acesso ao seu método principal.",
  security_recovery_regenerate: "Regenerar",
  security_recovery_download: "Baixar .txt",
  security_recovery_copy_all: "Copiar todos",
  security_recovery_copied: "Copiado",
  security_recovery_regenerated: "Novos códigos gerados",
  security_recovery_warning_title: "Copie-os agora: eles são exibidos apenas uma vez",
  security_recovery_warning_body:
    "Ao sair desta página não poderemos exibi-los novamente. Guarde-os no seu gerenciador de senhas ou onde preferir.",
  security_recovery_empty_hint:
    "Os códigos são gerados automaticamente ao ativar o 2FA. Se você não os salvou, regenere para obter um novo conjunto.",

  // Enable 2FA Modal
  enable_twofa_title: "Ativar autenticação de dois fatores",
  enable_twofa_scan_instructions:
    "Escaneie este código QR com seu aplicativo de autenticação (Google Authenticator, Authy, etc.)",
  enable_twofa_manual_entry: "Ou insira manualmente este código secreto:",
  enable_twofa_enter_code: "Digite o código de 6 dígitos do seu aplicativo",
  enable_twofa_verify_button: "Verificar e ativar",
  enable_twofa_cancel_button: "Cancelar",
  enable_twofa_success: "2FA ativado com sucesso",

  // Disable 2FA Modal
  disable_twofa_title: "Desativar autenticação de dois fatores",
  disable_twofa_description: "Para desativar o 2FA, digite seu código de autenticação atual",
  disable_twofa_warning: "Aviso: Isso reduzirá a segurança da sua conta",
  disable_twofa_verify_button: "Desativar 2FA",
  disable_twofa_cancel_button: "Cancelar",
  disable_twofa_success: "2FA desativado com sucesso",

  // Comuns
  copy_button: "Copiar",
  copied_message: "Copiado para a área de transferência",
  copy_error_message: "Não foi possível copiar para a área de transferência",
  error_invalid_code: "Código inválido. Por favor, tente novamente.",
  error_generic: "Ocorreu um erro. Por favor, tente mais tarde.",

  // API Keys
  api_keys_empty: "Ainda não há API Keys criadas para esta organização.",
  api_keys_docs_button: "Documentação da API",
  api_keys_enable_action: "Habilitar",
  api_keys_disable_action: "Desabilitar",
  api_keys_edit_ips_button: "Editar IPs",
  api_keys_disable_title: "Desativar esta API key?",
  api_keys_disable_subtitle: "Ação reversível — você pode reativá-la quando quiser.",
  api_keys_disable_confirm: "Sim, desativar",
  api_keys_disable_cancel: "Cancelar",
  api_keys_disable_success: "API Key desativada",
  api_keys_enable_success: "API Key ativada",
  api_keys_disable_impact_title: "Integrações que usam esta chave deixarão de funcionar",
  api_keys_disable_impact_unauthorized:
    "Todas as requisições à API com esta chave retornarão 401 Unauthorized.",
  api_keys_disable_impact_integrations:
    "Serviços que dependem dela (backend, jobs, etc.) serão interrompidos.",
  api_keys_disable_impact_reversible:
    "Você pode reativá-la quando quiser — ela não é excluída nem rotacionada.",
  api_keys_edit_ips_title: "IPs permitidas",
  api_keys_edit_ips_description:
    "Quando há IPs permitidas, solicitações de outros endereços são rejeitadas com",
  api_keys_edit_ips_placeholder: "54.213.10.45",
  api_keys_edit_ips_add: "Adicionar",
  api_keys_edit_ips_remove: "Remover",
  api_keys_edit_ips_save: "Salvar",
  api_keys_edit_ips_cancel: "Cancelar",
  api_keys_edit_ips_list_label: "IPs permitidas",
  api_keys_no_ips_hint: "Sem restrição de IP — a chave funciona de qualquer endereço.",
  api_keys_invalid_ip: "Formato inválido. Use IPv4 (ex. 54.213.10.45) ou CIDR (ex. 10.0.0.0/24).",
  api_keys_ip_duplicate: "Essa IP já está na lista.",
  api_keys_update_success: "API Key atualizada",
  api_keys_admin_no_ip_warning:
    "Esta é uma chave ADMIN sem restrição de IP — recomendamos fortemente limitá-la aos IPs do seu backend de produção.",
  api_keys_add_ip_label: "Adicionar IP ou faixa (CIDR)",
  api_keys_ip_label_placeholder: "Rótulo (opcional)",
  api_keys_any_ip_pill: "Qualquer IP",
  api_keys_ip_entry_singular: "entrada",
  api_keys_ip_entry_plural: "entradas",
  api_keys_your_current_ip_is: "Seu IP atual é",
  api_keys_add_my_ip: "Adicionar",
  api_keys_my_ip_label_default: "Meu IP atual",
  api_keys_ip_added: "Adicionada",
  api_keys_my_ip_detecting: "Detectando seu IP atual…",
  api_keys_my_ip_unavailable:
    "Não foi possível detectar seu IP automaticamente. Você pode digitá-lo manualmente acima.",
  api_keys_create_button: "Criar API key",
  api_keys_create_title: "Criar API key",
  api_keys_create_name_label: "Nome",
  api_keys_create_name_hint: "Para identificá-la em logs e auditoria.",
  api_keys_create_name_placeholder: "Ex. Backend de produção",
  api_keys_create_scopes_label: "Permissões",
  api_keys_create_scopes_hint: "Selecione apenas o mínimo necessário.",
  api_keys_create_scopes_selected: "{{count}} selecionados",
  api_keys_create_quick_readonly: "Somente leitura",
  api_keys_create_quick_all: "Tudo",
  api_keys_create_quick_none: "Nenhum",
  api_keys_create_group_select_all: "Todos",
  api_keys_create_group_clear: "Remover",
  api_keys_create_advanced: "Configuração avançada",
  api_keys_create_advanced_hint: "Restrições de IP",
  api_keys_create_ip_section_label: "Restrição de IPs (allowlist)",
  api_keys_create_once_hint: "Você verá a chave apenas uma vez após criá-la.",
  api_keys_create_submit: "Criar chave",
  api_keys_create_cancel: "Cancelar",
  api_keys_create_success: "API key criada.",
  api_keys_create_error: "Não foi possível criar a API key.",
  api_keys_create_name_required: "Informe um nome para a chave.",
  api_keys_create_scopes_required: "Selecione pelo menos uma permissão.",
  api_keys_created_banner_title: "Copie sua API key agora",
  api_keys_created_banner_warning:
    "Por segurança, esta chave é exibida apenas uma vez. Você não poderá vê-la novamente.",
  api_keys_created_copy: "Copiar",
  api_keys_created_copied: "Copiada",
  api_keys_created_dismiss: "Já guardei",
  api_keys_no_write_title: "A criação de API keys está restrita",
  api_keys_no_write_description:
    "Para habilitar a criação de chaves precisamos validar seu caso de uso. Escreva para {{email}} e ativamos para sua organização.",
  api_keys_scope_group_identities: "Titulares",
  api_keys_scope_group_payments: "Pagamentos",
  api_keys_scope_group_wallets: "Carteiras",
  api_keys_scope_group_cards: "Cartões",
  api_keys_scope_group_webhooks: "Webhooks",
  api_keys_scope_identities_read: "Ver titulares",
  api_keys_scope_identities_write: "Criar e editar titulares",
  api_keys_scope_payments_read: "Ver pagamentos e cotações",
  api_keys_scope_payments_write: "Criar cobranças e pagamentos",
  api_keys_scope_wallets_read: "Ver saldos e movimentações",
  api_keys_scope_wallets_write: "Ativar e administrar carteiras",
  api_keys_scope_cards_read: "Ver cartões",
  api_keys_scope_cards_write: "Criar e administrar cartões",
  api_keys_scope_cards_topup: "Recarregar cartões",
  api_keys_scope_cards_transfer: "Transferir entre cartões",
  api_keys_scope_webhooks_read: "Ver a configuração e as entregas de webhooks",
  api_keys_scope_webhooks_write: "Configurar o endpoint de webhooks",
  relative_time_now: "agora",
  relative_time_minutes: "há {{n}} min",
  relative_time_hours: "há {{n}} h",
  relative_time_days: "há {{n}} d",

  // Access & permissions (RBAC)
  settings_group_access: "Acesso e permissões",
  access_users_nav_label: "Usuários",
  access_eyebrow: "Acesso e permissões",
  access_users_title: "Usuários",
  access_users_sub:
    "Pessoas da equipe. Cada uma recebe perfis que determinam seu acesso efetivo, resolvido deny-first.",
  access_stat_active: "Ativos",
  access_stat_no_roles: "Sem perfis",
  access_search_person_placeholder: "Buscar pessoa ou e-mail",
  access_filter_all_roles: "Todos os perfis",
  access_stat_total: "Total",
  access_filter_all_statuses: "Todos os status",
  access_status_active: "Ativo",
  access_status_inactive: "Inativo",
  access_status_suspended: "Suspenso",
  access_status_pending_verification: "Pendente de verificação",
  access_role_filter_placeholder: "Filtrar por perfil",
  access_search_min_hint: "Digite pelo menos {{min}} caracteres para buscar",
  access_col_person: "Pessoa",
  access_col_roles: "Perfis atribuídos",
  access_col_effective: "Acesso efetivo",
  access_col_actions: "Ações",
  access_badge_you: "VOCÊ",
  access_badge_external: "EXT",
  access_badge_pending: "PENDENTE",
  access_badge_no_roles: "SEM PERFIS",
  access_badge_api_key: "API KEY",
  access_badge_roles_unavailable: "PERFIS INDISPONÍVEIS",
  access_roles_overflow_action: "Ver todos os perfis (mais {{count}})",
  access_roles_overflow_more: "Perfis adicionais: {{count}}",
  access_effective_unknown_title:
    "Não foi possível carregar os perfis desta entrada — o acesso efetivo é desconhecido, não confirmado como sem acesso.",
  access_effective_catalog_unknown_title:
    "O catálogo de perfis não está disponível — o acesso efetivo é desconhecido, não confirmado como sem acesso.",
  access_catalog_unavailable:
    "Não foi possível carregar o catálogo de perfis (requer a permissão roles:read). O acesso efetivo não pode ser calculado e a gestão de perfis está desabilitada; os perfis atribuídos são exibidos apenas a título informativo.",
  access_roles_partial_fail:
    "Não foi possível carregar os perfis de {{count}} entradas. O acesso é exibido como indisponível (desconhecido), não como sem acesso.",
  access_action_roles: "Perfis",
  access_action_view: "Ver",
  access_users_footnote:
    "O acesso efetivo é o resultado líquido após combinar todos os perfis e resolver as políticas deny-first.",
  access_users_load_failed: "Não foi possível carregar os usuários.",
  access_no_results: "Sem resultados.",
  access_no_access_title: "Você não tem permissão para administrar o acesso",
  access_no_access_description:
    "Seu perfil não inclui a permissão necessária. Peça a um administrador que conceda acesso a usuários e perfis.",
  access_readonly_note: "Com o seu perfil você pode ver o acesso, mas não modificá-lo.",
  access_view_as_label: "Pré-visualizar como",
  access_view_as_editor: "Editor",
  access_view_as_viewer: "Somente leitura",
  access_view_as_demo: "DEMO · apenas esta sessão",
  access_effective_granted_title: "permissões concedidas",
  access_effective_denied_title: "deny ativos",

  // Access — invite person
  access_invite_action: "Convidar pessoa",
  access_invite_title: "Convidar pessoa",
  access_invite_sub:
    "A pessoa receberá um e-mail com um link de uso único para criar sua conta e entrar na sua organização.",
  access_invite_email_label: "E-mail",
  access_invite_email_placeholder: "pessoa@empresa.com",
  access_invite_email_required: "O e-mail é obrigatório.",
  access_invite_email_invalid: "Insira um e-mail válido.",
  access_invite_field_max: "Máximo de 255 caracteres.",
  access_invite_name_label: "Nome (opcional)",
  access_invite_name_placeholder: "Nome e sobrenome",
  access_invite_language_label: "Idioma do convite",
  access_invite_language_hint: "Idioma em que o e-mail de convite será enviado.",
  access_invite_cancel: "Cancelar",
  access_invite_submit: "Enviar convite",
  access_invite_success: "Convite enviado para {{email}}.",
  access_invite_roles_label: "Acessos com que entra",
  access_invite_roles_hint:
    "As permissões de somente leitura vêm marcadas. Adicione as de escrita que a pessoa precisar e serão atribuídas no momento em que aceitar.",
  access_invite_roles_search: "Buscar por nome ou identificador",
  access_invite_roles_clear: "Remover todos",
  access_invite_roles_no_matches: "Nenhuma função corresponde à busca",
  access_invite_roles_global: "Global",
  access_invite_roles_none_selected: "Sem funções: entrará somente com leitura",
  access_invite_roles_count: "{{count}} funções selecionadas",
  access_invite_access_note_with_roles:
    "Ao aceitar o convite, as {{count}} funções selecionadas são atribuídas. Depois você pode ajustá-las no catálogo de funções desta mesma seção.",
  access_invite_access_note:
    "A pessoa entrará com acesso somente leitura. Quando aceitar o convite aparecerá nesta tabela e você poderá atribuir os perfis necessários.",

  // Access — API keys as principals
  access_apikeys_nav_label: "API Keys",
  access_apikeys_title: "API Keys",
  access_apikeys_sub:
    "As chaves de integração são principais como as pessoas: recebem os mesmos perfis e compartilham o avaliador de permissões deny-first.",
  access_apikeys_stat_keys: "Chaves",
  access_apikeys_truncated:
    "Mostrando as primeiras {{shown}} de {{total}} chaves. Use a busca para encontrar uma chave específica; a contagem, o simulador e os membros por perfil refletem apenas as chaves exibidas.",
  access_apikeys_search_placeholder: "Buscar chave",
  access_col_key: "Chave",
  access_apikeys_footnote:
    "As API keys recebem perfis como as pessoas; o acesso efetivo resulta de resolver suas políticas deny-first.",
  access_apikeys_admin_badge: "ADMIN",
  access_apikeys_super_badge: "SUPER",
  access_apikeys_inactive: "INATIVA",
  access_apikeys_more_actions: "Mais ações",
  access_apikeys_ip_count_singular: "1 IP",
  access_apikeys_ip_count_plural: "{{count}} IPs",
  access_apikeys_any_ip: "qualquer IP",

  // Access — assignment drawer + auto-save + matrix
  access_drawer_apply_immediately: "As alterações são salvas automaticamente.",
  access_drawer_readonly: "Somente leitura.",
  access_drawer_close: "Fechar",
  access_drawer_roles_count: "Perfis · {{count}} atribuídos",
  access_drawer_no_roles_available: "Não há perfis disponíveis.",
  access_drawer_search_roles_placeholder: "Buscar perfil",
  access_drawer_no_role_matches: "Nenhum perfil corresponde à busca.",
  access_drawer_group_broad: "Acesso amplo",
  access_drawer_group_org: "Perfis de organização",
  access_drawer_group_empty: "Sem permissões",
  access_drawer_group_unknown: "Sem catalogar",
  access_drawer_deny_notice:
    "Há {{count}} política(s) deny ativas. Elas bloqueiam permissões mesmo que outro perfil as conceda.",
  access_drawer_effective_title: "Acesso efetivo resultante",
  access_drawer_effective_hint: "* = deny vence allow",
  access_drawer_no_roles_empty: "Sem perfis — sem nenhum acesso (deny por padrão).",
  access_saved_saving: "Salvando…",
  access_saved_done: "Alterações salvas automaticamente",
  access_saved_error: "Não foi possível salvar as alterações",

  // Access — friendly labels for the real catalog (backend Module)
  access_mod_users: "Usuários",
  access_mod_api_key: "API keys",
  access_mod_roles: "Perfis",
  access_mod_policies: "Políticas",
  access_mod_organizations: "Organizações",
  access_mod_organization_accounts: "Contas de organização",
  access_mod_identities: "Identidades (KYC)",
  access_mod_wallets: "Wallets",
  access_mod_wallets_transfer_sensitive: "Transferência sensível de wallet",
  access_mod_cards: "Cartões",
  access_mod_cards_topup: "Recargas de cartão",
  access_mod_cards_transfer: "Transferências de cartão",
  access_mod_cards_sensitive: "Dados sensíveis de cartão",
  access_mod_cards_topup_sensitive: "Recarga sensível de cartão",
  access_mod_fees: "Comissões",
  access_mod_fee_configurations: "Configuração de comissões",
  access_mod_payments: "Motor de pagamentos",
  access_mod_payout_batches: "Pagamentos em lote",
  access_mod_payout_batches_approve: "Aprovação de pagamentos em lote",
  access_mod_clients: "Clientes",
  access_mod_client_accounts: "Contas de cliente",
  access_mod_operations: "Operações",
  access_mod_operations_payments: "Pagamentos / Dispersões",
  access_mod_operations_confirmations: "Confirmações",
  access_mod_operations_notes: "Notas de operação",
  access_mod_operations_shipping_quotes: "Cotações de envio",
  access_mod_operations_shipping_quotes_coloca: "Cotações Coloca",
  access_mod_operations_audit: "Auditoria",
  access_mod_operations_public_accounts: "Contas públicas",
  access_mod_operations_notifications: "Notificações",

  // Access — Roles
  access_scope_global: "GLOBAL",
  access_scope_org: "ORG",
  access_roles_nav_label: "Perfis",
  access_roles_title: "Perfis",
  access_roles_sub:
    "Um perfil agrupa políticas e é atribuído a usuários e API keys. Os perfis globais são administrados pela Coloca.",
  access_roles_create: "Criar perfil",
  access_roles_group_global: "Perfis globais",
  access_roles_group_global_note: "Administrados pela Coloca",
  access_roles_group_org: "Perfis da organização",
  access_roles_group_org_note: "Editáveis e excluíveis",
  access_roles_group_org_empty: "Você ainda não criou perfis próprios",
  access_roles_empty_group: "Nenhum perfil aqui.",
  access_page_refresh: "Atualizar",
  access_page_clear_filters: "Limpar filtros",
  access_page_scope_label: "Âmbito",
  access_page_scope_all: "Todos",
  access_page_col_actions: "Ações",
  access_page_col_scope: "Âmbito",
  access_page_empty_filtered_body: "Tente outro termo ou mude os filtros.",
  access_roles_search_placeholder: "Buscar por nome, slug ou descrição",
  access_roles_kpi_group_label: "Resumo do catálogo de perfis",
  access_roles_kpi_total: "Perfis",
  access_roles_kpi_deny: "Com deny",
  access_roles_kpi_deny_meta: "Retiram acesso",
  access_roles_kpi_no_policies: "Sem políticas",
  access_roles_kpi_no_policies_meta: "Não concedem nada",
  access_roles_kpi_no_members: "Sem atribuição",
  access_roles_col_role: "Perfil",
  access_roles_col_policies: "Políticas",
  access_roles_col_reach: "Alcance",
  access_roles_col_members: "Atribuições",
  access_roles_no_policies_badge: "Sem políticas",
  access_roles_empty_title: "Ainda não há perfis",
  access_roles_empty_body: "Crie o primeiro para começar a agrupar políticas e poder atribuí-las.",
  access_roles_empty_filtered_title: "Nenhum perfil corresponde",
  access_roles_protected_hint: "Perfil do sistema, somente leitura",
  access_roles_readonly_note: "Você pode consultar o catálogo, mas não criar nem editar perfis.",
  access_policies_search_placeholder: "Buscar por nome, descrição ou permissão (recurso:ação)",
  access_policies_kpi_group_label: "Resumo do catálogo de políticas",
  access_policies_kpi_total: "Políticas",
  access_policies_kpi_allow: "Allow",
  access_policies_kpi_deny: "Deny",
  access_policies_kpi_deny_meta: "Vencem qualquer allow",
  access_policies_kpi_unused: "Sem uso",
  access_policies_kpi_unused_meta: "Nenhum perfil as vincula",
  access_policies_col_policy: "Política",
  access_policies_col_effect: "Efeito",
  access_policies_col_permissions: "Permissões",
  access_policies_col_used_by: "Usada por",
  access_policies_unused_badge: "Sem uso",
  access_policies_usage_unknown_title:
    "Não conseguimos ler o catálogo de perfis, então não sabemos se algum perfil a vincula.",
  access_policies_usage_unknown_meta: "Desconhecido",
  access_policies_usage_unavailable:
    "Sem acesso ao catálogo de perfis não é possível saber quais políticas estão vinculadas, então excluir não está disponível.",
  access_policies_empty_title: "Ainda não há políticas",
  access_policies_empty_body: "Crie a primeira para agrupar permissões e poder vinculá-las a um perfil.",
  access_policies_empty_filtered_title: "Nenhuma política corresponde",
  access_policies_protected_hint: "Política do sistema, somente leitura",
  access_policies_readonly_note: "Você pode consultar o catálogo, mas não criar nem editar políticas.",
  access_apikeys_kpi_group_label: "Resumo do catálogo de chaves",
  access_apikeys_kpi_total: "Chaves",
  access_apikeys_kpi_active: "Ativas",
  access_apikeys_kpi_no_roles: "Sem perfis",
  access_apikeys_kpi_no_roles_meta: "Não autorizam nada",
  access_apikeys_kpi_no_roles_partial: "Mínimo: faltam perfis por ler",
  access_apikeys_kpi_not_active: "Inativas ou expiradas",
  access_apikeys_col_organization: "Organização",
  access_apikeys_col_status: "Estado",
  access_apikeys_status_active: "Ativa",
  access_apikeys_status_expired: "Expirada",
  access_apikeys_status_inactive: "Inativa",
  access_apikeys_org_global: "Global",
  access_apikeys_truncated_page:
    "Mostrando as primeiras {{shown}} de {{total}} chaves. A busca, os filtros e os indicadores desta página descrevem apenas as chaves carregadas.",
  access_apikeys_empty_title: "Ainda não há chaves de API",
  access_apikeys_empty_body: "Crie a primeira para que uma integração possa se autenticar.",
  access_apikeys_empty_filtered_title: "Nenhuma chave corresponde",
  access_apikeys_empty_filtered_body: "Tente outro termo ou mude o filtro de perfil.",
  access_role_default_badge: "DEFAULT",
  access_role_policy_count_singular: "1 política",
  access_role_policy_count_plural: "{{count}} políticas",
  access_role_has_deny: "com deny",
  access_role_editor_new: "Criar perfil",
  access_role_editor_new_sub: "Defina um perfil próprio agrupando políticas.",
  access_role_editor_edit: "Editar perfil",
  access_role_editor_view: "Ver perfil",
  access_role_name_label: "Nome do perfil",
  access_role_name_placeholder: "Ex. Aprovador de pagamentos",
  access_role_name_required: "Insira um nome para o perfil.",
  access_role_desc_label: "Descrição",
  access_role_desc_placeholder: "Para que serve este perfil.",
  access_role_policies_label: "Políticas do perfil",
  access_role_policies_allow: "Permitir (allow)",
  access_role_policies_deny: "Negar (deny)",
  access_role_policies_deny_hint: "Estas vencem qualquer allow do perfil.",
  access_role_policies_none_available: "Nenhuma disponível.",
  access_role_effective_title: "Acesso efetivo resultante",
  access_role_no_policies_empty: "Sem políticas — sem nenhum acesso (deny por padrão).",
  access_role_readonly_note: "Perfil global ou protegido administrado pela Coloca · somente leitura.",
  access_role_save: "Salvar",
  access_role_create_action: "Criar perfil",
  access_role_cancel: "Cancelar",
  access_role_delete: "Excluir",
  access_role_delete_title: "Excluir perfil?",
  access_role_delete_desc:
    "O perfil “{{name}}” será removido de qualquer usuário ou API key que o use. Esta ação não pode ser desfeita.",
  access_role_delete_confirm: "Excluir perfil",
  access_role_created: "Perfil criado.",
  access_role_updated: "Perfil atualizado.",
  access_role_deleted: "Perfil excluído.",
  access_role_member_count_platform_one: "1 na plataforma",
  access_role_member_count_platform: "{{count}} na plataforma",
  access_role_member_count_org_one: "1 na sua organização",
  access_role_member_count_org: "{{count}} na sua organização",
  access_role_members_users_label: "Usuários com este perfil",
  access_role_members_keys_note:
    "Também há API keys com este perfil; não podem ser listadas por perfil, mas contam no total.",
  access_role_members_unavailable: "Não foi possível carregar a lista de usuários.",
  access_role_members_label: "Principais que usam este perfil",
  access_role_no_members: "Nenhum principal usa este perfil ainda.",
  access_role_members_more: "+{{count}} mais",
  access_role_delete_desc_members:
    "O perfil “{{name}}” será removido de {{count}} principal(is) que o usam. Esta ação não pode ser desfeita.",

  // Access — editor validation (shared by role + policy editors; limits mirror the backend DTOs)
  access_validation_name_max: "Máximo de 120 caracteres.",
  access_validation_desc_max: "Máximo de 500 caracteres.",

  // Access — Policies
  access_policy_effect_allow: "ALLOW",
  access_policy_effect_deny: "DENY",
  access_policies_nav_label: "Políticas",
  access_policies_title: "Políticas",
  access_policies_sub:
    "Uma política agrupa permissões recurso:ação sob um único efeito. As políticas deny sempre vencem as allow.",
  access_policies_create: "Nova política",
  access_policies_group_allow: "Permitir (allow)",
  access_policies_group_allow_note: "Concedem acesso a recursos.",
  access_policies_group_deny: "Negar (deny)",
  access_policies_group_deny_note: "Bloqueiam o acesso mesmo que outra o conceda.",
  access_policies_empty_group: "Nenhuma política neste grupo.",
  access_policy_stmt_summary: "{{permits}} permissões · {{resources}} recursos",
  access_policy_used_by_singular: "usada por 1 perfil",
  access_policy_used_by_plural: "usada por {{count}} perfis",
  access_policy_editor_new: "Nova política",
  access_policy_editor_new_sub: "Defina um bloco de permissões reutilizável.",
  access_policy_editor_edit: "Editar política",
  access_policy_editor_view: "Ver política",
  access_policy_name_label: "Nome",
  access_policy_name_placeholder: "Ex. Pagamentos · Operação",
  access_policy_name_required: "Insira um nome para a política.",
  access_policy_name_taken: "Já existe uma política com esse nome.",
  access_policy_desc_label: "Descrição",
  access_policy_desc_placeholder: "O que esta política concede ou nega.",
  access_policy_effect_label: "Efeito",
  access_policy_effect_allow_title: "Permitir",
  access_policy_effect_allow_hint: "Concede acesso",
  access_policy_effect_deny_title: "Negar",
  access_policy_effect_deny_hint: "Bloqueia — vence allow",
  access_policy_statements_label: "Permissões desta política",
  access_policy_statements_hint: "recurso : ação",
  access_policy_statements_required: "Selecione ao menos uma permissão.",
  access_policy_permits_singular: "1 permissão",
  access_policy_permits_plural: "{{count}} permissões",
  access_policy_readonly_note: "Política global ou protegida administrada pela Coloca · somente leitura.",
  access_policy_save: "Salvar",
  access_policy_create_action: "Criar política",
  access_policy_cancel: "Cancelar",
  access_policy_delete: "Excluir",
  access_policy_delete_disabled_hint: "Remova-a dos perfis antes de excluir.",
  access_policy_delete_title: "Excluir política?",
  access_policy_delete_desc: "A política “{{name}}” será excluída. Esta ação não pode ser desfeita.",
  access_policy_delete_confirm: "Excluir política",
  access_policy_delete_in_use:
    "Não é possível excluir: a política está em uso por um ou mais perfis. Remova-a deles primeiro.",
  access_policy_created: "Política criada.",
  access_policy_updated: "Política atualizada.",
  access_policy_deleted: "Política excluída.",

  // Access — Simulator
  access_sim_nav_label: "Simulador",
  access_sim_title: "Simulador de acesso",
  access_sim_sub:
    "Verifique por que um principal pode ou não executar uma ação — qual perfil e política a concedem, e se um deny a está anulando.",
  access_sim_principal_label: "Principal",
  access_sim_principal_placeholder: "Selecione um principal",
  access_sim_no_principals: "Não há principais (usuários ou API keys) para simular.",
  access_sim_page_scope_note:
    "Você pode simular os {{count}} principais da página atual de Usuários e as API keys carregadas. Filtre ou pagine essa tabela para alcançar os demais.",
  access_sim_selection_dropped:
    "O principal que você estava simulando não está mais na página atual. Escolha-o novamente ou ajuste os filtros de Usuários.",
  access_sim_partial_principals:
    "{{count}} entradas foram excluídas do simulador porque seus perfis não puderam ser carregados.",
  access_sim_matrix_hint: "Clique em uma permissão para inspecioná-la",
  access_sim_pick_prompt: "Selecione uma permissão na matriz para ver como ela é resolvida.",
  access_sim_explanation_title: "Explicação",
  access_sim_result_allow: "PERMITIDO",
  access_sim_result_deny: "NEGADO",
  access_sim_result_none: "NEGADO (por padrão)",
  access_sim_reason_allowed_by: "Permitido por",
  access_sim_reason_denied_by: "Negado por",
  access_sim_reason_overridden: "Allow anulado (não surte efeito)",
  access_sim_summary_allow: "concedido por política allow",
  access_sim_summary_deny: "bloqueado por política deny",
  access_sim_summary_deny_wins: "deny vence {{count}} allow",
  access_sim_summary_none: "nenhum allow corresponde",
  access_sim_none_detail:
    "Nenhuma política atribuída a {{name}} concede {{perm}}. Pela regra default-deny, sem um allow explícito o acesso é negado.",
  access_sim_rule:
    "Regra: qualquer deny vence primeiro; sem deny, basta um allow; sem nenhum, é negado por padrão.",
  access_sim_via_policy: "política {{policy}}",
  access_mod_organization_webhooks: "Webhooks",

  // Webhooks (saída, grupo Desenvolvedores)
  webhooks_nav_label: "Webhooks",
  webhooks_section_eyebrow: "Desenvolvedores",
  webhooks_section_title: "Webhooks de saída",
  webhooks_section_sub:
    "A Coloca avisa o seu servidor sempre que um payin, um payout ou um swap muda de status. Um único endpoint HTTPS recebe todos os eventos.",
  webhooks_load_error: "Não foi possível carregar a configuração de webhooks.",
  webhooks_retry_load: "Tentar novamente",
  webhooks_empty_title: "Você ainda não recebe eventos",
  webhooks_empty_desc:
    "Cadastre a URL HTTPS do seu servidor. Cada entrega traz o cabeçalho x-secret para você confirmar que vem da Coloca.",
  webhooks_add_endpoint: "Adicionar endpoint",
  webhooks_endpoint_label: "Endpoint",
  webhooks_secret_label: "Segredo",
  webhooks_secret_header_hint: "Enviado no cabeçalho {{header}} de cada entrega",
  webhooks_status_active: "Ativo",
  webhooks_status_paused: "Pausado",
  webhooks_status_auto_disabled: "Desativado por falhas",
  webhooks_disabled_reason_streak:
    "Pausamos as entregas após 50 falhas consecutivas do seu servidor. Corrija, teste a conexão e reative o endpoint.",
  webhooks_disabled_reason_prolonged:
    "Pausamos as entregas após 24 horas sem uma resposta bem-sucedida do seu servidor. Corrija, teste a conexão e reative o endpoint.",
  webhooks_paused_hint:
    "Enquanto estiver pausado, não enfileiramos novas entregas. O teste de conexão continua funcionando para você verificar a correção.",
  webhooks_health_failures: "Falhas seguidas",
  webhooks_health_last_success: "Último sucesso",
  webhooks_health_last_failure: "Última falha",
  webhooks_health_never: "Nunca",
  webhooks_toggle_aria: "Ativar ou pausar as entregas",
  webhooks_action_edit_url: "Alterar URL",
  webhooks_action_test: "Enviar evento de teste",
  webhooks_action_rotate: "Rotacionar segredo",
  webhooks_action_delete: "Remover endpoint",
  webhooks_toast_saved: "Endpoint salvo",
  webhooks_toast_paused: "Entregas pausadas",
  webhooks_toast_resumed: "Entregas retomadas",
  webhooks_toast_rotated: "Segredo rotacionado",
  webhooks_toast_deleted: "Endpoint removido",
  webhooks_toast_resend_queued: "Reenvio enfileirado como uma nova entrega",
  webhooks_toast_retry_queued: "Entrega reenfileirada",
  webhooks_error_no_write_permission: "Seu perfil não pode alterar a configuração de webhooks.",
  webhooks_read_only_notice:
    "Seu perfil só permite visualizar os webhooks. Para configurá-los, peça a um administrador da sua organização que atribua a você o perfil de escrita de webhooks em Configurações → Usuários.",
  webhooks_url_dialog_title_create: "Adicionar endpoint",
  webhooks_url_dialog_title_edit: "Alterar a URL do endpoint",
  webhooks_url_dialog_desc:
    "Precisa ser HTTPS e responder 2xx em menos de 10 segundos. Em caso de falha, tentamos até 5 vezes com esperas crescentes.",
  webhooks_url_field_label: "URL do seu servidor",
  webhooks_url_field_placeholder: "https://api.suaempresa.com/coloca/webhooks",
  webhooks_url_invalid: "Informe uma URL HTTPS válida.",
  webhooks_url_save: "Salvar endpoint",
  webhooks_url_register_and_verify: "Cadastrar e verificar",
  webhooks_url_cancel: "Cancelar",
  webhooks_secret_field_label: "Segredo compartilhado",
  webhooks_secret_field_hint_create:
    "Enviamos no cabeçalho {{header}} de cada evento. Use o que o seu servidor já espera, ou deixe em branco e nós geramos.",
  webhooks_secret_field_hint_edit:
    "Deixe em branco para manter o segredo atual. Se digitar um novo, ele passa a viajar em {{header}} imediatamente.",
  webhooks_secret_field_placeholder: "No mínimo 16 caracteres, sem espaços",
  webhooks_secret_generate: "Gerar um",
  webhooks_secret_invalid: "Use pelo menos {{min}} caracteres imprimíveis, sem espaços.",
  webhooks_handshake_explainer:
    "No cadastro enviamos um handshake de configuração ao seu servidor. Se responder 2xx, ativamos as entregas; se não, o endpoint fica pausado e mostramos o que ele respondeu.",
  webhooks_toast_saved_paused: "Endpoint salvo e pausado",
  webhooks_toast_handshake_ok: "Seu servidor respondeu: entregas ativadas",
  webhooks_toast_handshake_failed: "Endpoint salvo pausado: seu servidor não aceitou o handshake",
  webhooks_secret_banner_title: "Guarde este segredo agora",
  webhooks_secret_banner_warning:
    "Ele aparece só uma vez. Compare com o cabeçalho {{header}} de cada entrega para confirmar que vem da Coloca.",
  webhooks_secret_copy: "Copiar",
  webhooks_secret_copied: "Copiado",
  webhooks_secret_dismiss: "Já guardei",
  webhooks_secret_reveal: "Revelar",
  webhooks_secret_hide: "Ocultar",
  webhooks_error_no_reveal_permission: "Seu perfil não pode ver o segredo completo.",
  webhooks_rotate_title: "Rotacionar o segredo?",
  webhooks_rotate_desc:
    "As entregas passam a usar o novo segredo imediatamente. Atualize o seu servidor na mesma janela ou ele rejeitará os eventos.",
  webhooks_rotate_confirm: "Rotacionar segredo",
  webhooks_delete_title: "Remover o endpoint?",
  webhooks_delete_desc:
    "Deixamos de enviar eventos. O histórico de entregas é mantido e você pode cadastrar outro endpoint quando quiser.",
  webhooks_delete_confirm: "Remover endpoint",
  webhooks_handshake_verified_title: "Endpoint verificado em {{ms}} ms",
  webhooks_handshake_verified_detail:
    "Seu servidor devolveu o segredo correto, então confirmamos que o endpoint é seu. Já pode receber eventos.",
  webhooks_handshake_no_response_title: "Seu servidor não respondeu",
  webhooks_handshake_no_response_detail:
    "Não obtivemos nenhuma resposta: {{error}}. Verifique se a URL é alcançável pela internet, se o certificado é válido e se responde em menos de 10 segundos.",
  webhooks_handshake_http_error_title: "Seu servidor rejeitou o evento",
  webhooks_handshake_http_error_detail:
    "Respondeu HTTP {{status}} em {{ms}} ms. Precisamos de um 2xx para considerar o endpoint verificado.",
  webhooks_handshake_invalid_response_title: "A resposta não é JSON",
  webhooks_handshake_invalid_response_detail:
    "Seu servidor respondeu corretamente, mas o corpo não é um objeto JSON. Devolva o valor do cabeçalho {{header}} em um campo chamado secret:",
  webhooks_handshake_secret_missing_title: "Falta o segredo na resposta",
  webhooks_handshake_secret_missing_detail:
    "Seu servidor respondeu 200 sem devolver o segredo, e sem isso qualquer URL que responda passaria no teste. Devolva o valor do cabeçalho {{header}} em um campo chamado secret:",
  webhooks_handshake_secret_mismatch_title: "O segredo não coincide",
  webhooks_handshake_secret_mismatch_detail:
    "Seu servidor devolveu um segredo diferente do configurado. Compare com o cabeçalho {{header}} da requisição que acabou de receber, ou rotacione o segredo se o seu estiver desatualizado:",
  webhooks_test_hint: "O teste ficou registrado no relatório de entregas como Teste · Ping.",
  webhooks_no_response: "sem resposta",
  webhooks_deliveries_title: "Entregas",
  webhooks_deliveries_sub:
    "Cada tentativa com seu código HTTP e latência. Tente novamente as que falharam quando o seu servidor estiver pronto.",
  webhooks_deliveries_refresh: "Atualizar",
  webhooks_deliveries_error: "Não foi possível carregar as entregas.",
  webhooks_deliveries_empty_title: "Nenhuma entrega ainda",
  webhooks_deliveries_empty_desc:
    "Elas aparecerão aqui quando algo acontecer com seus pagamentos, identidades, cartões ou carteiras, ou quando você enviar um evento de teste.",
  webhooks_deliveries_empty_filtered: "Nenhuma entrega corresponde aos filtros",
  webhooks_filter_status: "Status",
  webhooks_filter_type: "Tipo",
  webhooks_filter_event: "Evento",
  webhooks_filter_status_code: "Código HTTP",
  webhooks_filter_range: "Datas",
  webhooks_filter_all: "Todos",
  webhooks_filter_apply: "Aplicar filtros",
  webhooks_filter_clear: "Limpar filtros",
  webhooks_th_created: "Data",
  webhooks_th_event: "Evento",
  webhooks_th_status: "Status",
  webhooks_th_http: "HTTP",
  webhooks_th_attempts: "Tentativas",
  webhooks_th_latency: "Latência",
  webhooks_status_pending: "Em andamento",
  webhooks_status_delivered: "Entregue",
  webhooks_status_failed: "Rejeitada",
  webhooks_status_exhausted: "Sem tentativas",
  webhooks_type_payments: "Pagamentos",
  webhooks_type_identities: "Identidades",
  webhooks_type_cards: "Cartões",
  webhooks_type_wallets: "Carteiras",
  webhooks_type_test: "Teste",
  webhooks_event_payin_created: "Payin criado",
  webhooks_event_payin_pending: "Payin pendente",
  webhooks_event_payin_approved: "Payin aprovado",
  webhooks_event_payin_confirmed: "Payin confirmado",
  webhooks_event_payin_settled: "Payin liquidado",
  webhooks_event_payin_rejected: "Payin rejeitado",
  webhooks_event_payin_reversed: "Payin estornado",
  webhooks_event_payout_created: "Payout criado",
  webhooks_event_payout_processing: "Payout em processamento",
  webhooks_event_payout_paid: "Payout pago",
  webhooks_event_payout_failed: "Payout com falha",
  webhooks_event_payout_cancelled: "Payout cancelado",
  webhooks_event_payout_reversed: "Payout estornado",
  webhooks_event_swap_completed: "Swap concluído",
  webhooks_event_identity_created: "Identidade criada",
  webhooks_event_kyc_approved: "Verificação aprovada",
  webhooks_event_kyc_rejected: "Verificação rejeitada",
  webhooks_event_cardholder_created: "Portador criado",
  webhooks_event_card_created: "Cartão criado",
  webhooks_event_card_status_changed: "Status do cartão alterado",
  webhooks_event_card_transaction_authorized: "Transação do cartão autorizada",
  webhooks_event_card_transaction_declined: "Transação do cartão recusada",
  webhooks_event_card_transaction_refunded: "Transação do cartão reembolsada",
  webhooks_event_card_transaction_reversed: "Transação do cartão estornada",
  webhooks_event_card_topped_up: "Cartão recarregado",
  webhooks_event_card_deposit_received: "Depósito cripto recebido",
  webhooks_event_card_withdrawn: "Saque do cartão",
  webhooks_event_card_wallet_recharged: "Carteira de cartões recarregada",
  webhooks_event_wallet_created: "Carteira criada",
  webhooks_event_ping: "Ping",
  webhooks_endpoint_disabled_error: "O endpoint estava pausado ou removido no momento da tentativa",
  webhooks_drawer_title: "Detalhe da entrega",
  webhooks_drawer_id: "ID da entrega",
  webhooks_drawer_event_id: "ID do recurso",
  webhooks_drawer_url: "Enviado para",
  webhooks_drawer_created: "Criada",
  webhooks_drawer_delivered: "Entregue",
  webhooks_drawer_last_error: "Último erro",
  webhooks_drawer_payload: "Corpo enviado",
  webhooks_drawer_response: "Resposta do seu servidor",
  webhooks_drawer_response_truncated: "Guardamos os primeiros 2 KB da resposta.",
  webhooks_drawer_response_empty: "Sem corpo de resposta",
  webhooks_drawer_retry: "Tentar entrega novamente",
  webhooks_drawer_resend: "Reenviar entrega",
  webhooks_drawer_resend_hint:
    "Esta entrega já chegou. Reenviá-la cria uma nova entrega com outro id de evento, então seu servidor vai processá-la uma segunda vez.",
  webhooks_drawer_retry_hint:
    "Esta entrega ainda está sendo tentada. Aguarde o término para poder reenfileirá-la.",
  webhooks_guide_title: "Como conectar seu servidor",
  webhooks_guide_sub:
    "Como configurar o segredo, quais eventos enviamos, o contrato do handshake e o que acontece ao rotacionar ou mudar a URL",
  webhooks_guide_setup_title: "Guarde o segredo no seu servidor",
  webhooks_guide_setup_body:
    "O handshake acontece no momento em que você registra a URL, então o segredo precisa estar guardado no seu servidor antes disso. Caso contrário a primeira verificação falha e o endpoint fica pausado.",
  webhooks_guide_setup_own:
    "Traga seu próprio segredo (recomendado): cole no campo Segredo compartilhado do formulário o mesmo valor que seu servidor já tem. Assim o endpoint é ativado na primeira tentativa.",
  webhooks_guide_setup_generated:
    "Ou deixe que a gente gere: copie do banner — ele aparece uma única vez —, guarde no seu servidor, envie um evento de teste e ative o endpoint.",
  webhooks_guide_setup_format:
    "Formato: de 16 a 255 caracteres ASCII imprimíveis, sem espaços. Guarde como variável de ambiente ou segredo, nunca no código.",
  webhooks_guide_receive_title: "Receba o evento",
  webhooks_guide_receive_body:
    "Enviamos um POST com um corpo JSON sempre no mesmo formato: roteie por type (o grupo) e event (o que aconteceu); data é o recurso exatamente como o seu endpoint público GET /:id o retorna. O segredo viaja no cabeçalho {{header}} em todas as entregas, não só no teste.",
  webhooks_guide_receive_dedupe:
    "Deduplique pelo id: ele se mantém igual em todas as novas tentativas de uma entrega. Reenviar daqui um evento já entregue gera um id novo.",
  webhooks_guide_receive_snapshot:
    "data é um retrato do momento do evento. Se você precisa do recurso como está agora, leia-o de novo com GET.",
  webhooks_guide_receive_order:
    "Os eventos podem chegar fora de ordem: compare created_at e aceite um evento sobre um recurso que você ainda não conhece.",
  webhooks_guide_handshake_title: "Devolva o segredo no evento de teste",
  webhooks_guide_handshake_body:
    "Quando chegar type test com event ping, responda 200 com um JSON que traga de volta o valor do cabeçalho {{header}} em um campo chamado secret. Sem esse eco não ativamos o endpoint: qualquer URL responde 200, e isso não prova quem está escutando. Os outros eventos precisam apenas de um 2xx.",
  webhooks_guide_verify_title: "Valide o segredo em cada requisição",
  webhooks_guide_verify_body:
    "Do seu lado, compare o cabeçalho {{header}} com o segredo que você guardou e rejeite com 401 se não coincidir, antes de processar qualquer coisa. Essa comparação é o que impede que um terceiro injete eventos falsos.",
  webhooks_guide_catalog_title: "Eventos que enviamos",
  webhooks_guide_catalog_body:
    "Escolha um grupo para ver seus eventos e um exemplo do corpo que você recebe.",
  webhooks_guide_catalog_kyb:
    "kyc_approved e kyc_rejected também cobrem a verificação de empresas (KYB): diferencie-as com data.type.",
  webhooks_guide_catalog_events: "Eventos",
  webhooks_guide_catalog_example: "Exemplo",
  webhooks_guide_rotation_title: "Rotacionar o segredo e mudar a URL",
  webhooks_guide_rotation_badge: "Pausa as entregas",
  webhooks_guide_rotation_rotate:
    "Ao rotacionar, o endpoint fica pausado imediatamente e repetimos o handshake. Se o seu servidor continuar respondendo o segredo anterior, ele fica desabilitado até você atualizá-lo.",
  webhooks_guide_rotation_url:
    "Mudar a URL funciona igual: é salvo pausado, rodamos o handshake contra o novo endereço e só então ele volta a ser ativado.",
  webhooks_guide_rotation_activate:
    "Ligar o switch também exige o handshake. Se o seu servidor não devolver o segredo, a ativação é recusada e o endpoint fica como estava.",
  webhooks_guide_rotation_order:
    "Por isso a ordem importa: atualize primeiro o segredo no seu servidor e depois envie um evento de teste daqui.",
  webhooks_guide_retries_title: "Novas tentativas e falhas",
  webhooks_guide_retries_body:
    "Você tem 10 segundos por tentativa. Um 5xx, um 408, um 429 ou um timeout são repetidos até 5 vezes com esperas crescentes de 1, 2, 4 e 8 minutos. Qualquer outro 4xx é uma rejeição definitiva e não é repetido. Se o seu endpoint acumular falhas avisamos por e-mail e, se continuar fora, nós mesmos o pausamos.",
  webhooks_activate_blocked: "Envie um evento de teste e passe o handshake antes de ativar o endpoint.",
  webhooks_disabled_reason_handshake:
    "Pausamos as entregas porque seu servidor não devolveu o segredo correto após a última mudança. Atualize-o, envie um evento de teste e ative novamente.",
  webhooks_toast_rotated_paused:
    "Segredo rotacionado e entregas pausadas: atualize seu servidor e ative o endpoint novamente",
  webhooks_toast_saved_revalidation_failed:
    "Endpoint salvo e pausado: seu servidor não devolveu o segredo após a mudança",
  webhooks_copy_aria: "Copiar",
  webhooks_copy_success: "Copiado para a área de transferência",

  // Account → Verification
  verification_nav_label: "Verificação",
  card_wallet_nav_label: "Carteira de cartões",
  dashboard_alerts_nav_label: "Avisos no dashboard",
  card_wallet_section_eyebrow: "Cartões",
  card_wallet_section_title: "Carteira de cartões",
  card_wallet_section_sub:
    "Um saldo em dólares da sua organização que conecta seus cartões: eles são carregados a partir dela e o que você retira deles volta para ela.",
  card_wallet_status_on: "Ativa",
  card_wallet_status_off: "Inativa",
  card_wallet_compare_without: "Sem a carteira",
  card_wallet_compare_with: "Com a carteira",
  card_wallet_row_load: "Carregar cartões",
  card_wallet_row_load_without: "Com pesos ou enviando cripto",
  card_wallet_row_load_with: "Também pela carteira, na hora",
  card_wallet_row_withdraw: "Retirar saldo de um cartão",
  card_wallet_row_withdraw_without: "Não é possível: só movê-lo para outro cartão",
  card_wallet_row_withdraw_with: "Sim: volta para a carteira",
  card_wallet_activate: "Conhecer e ativar",
  card_wallet_permanent_note: "Depois de ativada, só o suporte pode desativá-la.",
  card_wallet_on_body:
    "Seus cartões são carregados pela carteira na hora, e o que você retira deles volta para ela.",
  card_wallet_go_to_cards: "Ver em Cartões",
  card_wallet_on_note: "Para desativá-la, fale com o suporte.",
  payout_batch_approval_nav_label: "Pagamentos em lote",
  payout_batch_approval_section_eyebrow: "Pagamentos em lote",
  payout_batch_approval_section_title: "Aprovação de lotes",
  payout_batch_approval_section_sub: "Quem aprova um lote antes de os pagamentos saírem.",
  payout_batch_approval_mode_dual_title: "Outra pessoa aprova cada lote",
  payout_batch_approval_mode_dual_body:
    "Quem carrega ou envia um lote não pode aprová-lo: outra pessoa com permissão de aprovação o aprova com o código dela.",
  payout_batch_approval_mode_sole_title: "Você aprova seus próprios lotes",
  payout_batch_approval_mode_sole_body:
    "Você é a única pessoa da sua organização que pode aprovar lotes, então você mesmo os aprova com o seu código. Se outra pessoa receber essa permissão, cada lote vai precisar de uma segunda pessoa, a menos que você ative a autoaprovação.",
  payout_batch_approval_mode_self_title: "Autoaprovação ativada",
  payout_batch_approval_mode_self_body:
    "Quem prepara um lote pode aprová-lo com o código dele, sem esperar outra pessoa. Cada lote aprovado assim fica marcado no histórico.",
  payout_batch_approval_mode_none_title: "Ninguém pode aprovar lotes ainda",
  payout_batch_approval_mode_none_body:
    "Ninguém na sua organização tem permissão para aprovar lotes. Peça a quem administra os usuários para concedê-la a alguém.",
  payout_batch_approval_switch_label: "Autoaprovação",
  payout_batch_approval_switch_description:
    "Quem carrega ou envia um lote pode aprová-lo com o código dele, mesmo que outra pessoa possa fazê-lo.",
  payout_batch_approval_switch_aria: "Autoaprovação de lotes",
  payout_batch_approval_change_note:
    "Cada mudança pede o seu código, fica registrada e a equipe da Coloca é avisada.",
  payout_batch_approval_read_only_note: "Só quem pode aprovar lotes pode mudar isso.",
  payout_batch_approval_enable_title: "Ativar a autoaprovação",
  payout_batch_approval_enable_description: "Quem preparar um lote poderá aprová-lo sem uma segunda pessoa.",
  payout_batch_approval_disable_title: "Desativar a autoaprovação",
  payout_batch_approval_disable_description:
    "Cada lote voltará a precisar da aprovação de outra pessoa, quando houver.",
  payout_batch_approval_two_factor_required:
    "Ative a autenticação em duas etapas para mudar como os lotes são aprovados.",
  payout_batch_approval_enabled_toast: "Autoaprovação ativada",
  payout_batch_approval_disabled_toast: "Autoaprovação desativada",
  payout_batch_approval_load_error: "Não conseguimos ler como os lotes da sua organização são aprovados.",
  payout_batch_approval_retry: "Tentar de novo",
  verification_section_title: "Verificação da conta",
  verification_section_sub:
    "Sua verificação KYC ou KYB define quais operações você pode fazer. Aqui você pode iniciá-la, retomá-la e ver o que enviou.",
  verification_empty_title: "Você ainda não verificou sua conta",
  verification_empty_description:
    "Escolha se opera como pessoa física (KYC) ou como empresa (KYB) e conclua a verificação para habilitar todas as operações.",
  verification_type_label: "Tipo de verificação",
  verification_type_person: "Pessoa física (KYC)",
  verification_type_business: "Empresa (KYB)",
  verification_status_label: "Status",
  verification_verified_at: "Aprovada em {{date}}",
  verification_pending_hint: "Ainda não concluída. Retome de onde parou.",
  verification_in_review_hint: "Em análise. Avisaremos por e-mail assim que tivermos o resultado.",
  verification_expired_hint: "A verificação expirou. Inicie-a novamente para continuar operando.",
  verification_copy_link: "Copiar link de verificação",
  verification_copy_link_hint: "Envie a quem concluir a verificação, por exemplo o representante legal.",
  verification_data_title: "Dados enviados",
  verification_data_note:
    "Estes são os dados validados pela verificação. Para corrigi-los, fale com o suporte.",
  verification_field_name: "Nome",
  verification_field_legal_name: "Razão social",
  verification_field_document: "Documento",
  verification_field_tax_id: "Identificação fiscal",
  verification_field_country: "País",
  verification_field_birthdate: "Data de nascimento",
  verification_field_nationality: "Nacionalidade",
  verification_field_business_type: "Tipo de empresa",
  verification_field_incorporation_date: "Data de constituição",
  verification_field_representative: "Representante legal",
  verification_field_representative_document: "Documento do representante",
  verification_field_address: "Endereço",
  verification_field_representative_address: "Endereço do representante",
  verification_capabilities_title: "O que você pode fazer",
  verification_change_title: "Alterar identidade",
  verification_change_hint:
    "Verifique a conta com outra pessoa ou empresa, ou mude de pessoa física para empresa e vice-versa.",
  verification_change_identity: "Verificar com outra identidade",
  verification_change_dialog_title: "Verificar com outra identidade?",
  verification_change_dialog_description:
    "A verificação atual deixará de valer para sua conta e você não poderá enviar dinheiro até que a nova verificação seja aprovada. Você poderá escolher novamente entre pessoa física e empresa.",
  verification_change_dialog_confirm: "Sim, usar outra identidade",
  verification_change_dialog_cancel: "Cancelar",
  verification_change_cooldown_hint:
    "Você substituiu uma identidade verificada recentemente. Disponível novamente a partir de {{date}}.",
  verification_change_request: "Solicitar alteração antecipada",
  verification_change_request_sent: "Solicitação enviada. Operações vai analisar seu caso.",
  verification_error_load: "Não foi possível carregar o status da sua verificação.",
  verification_retry: "Tentar novamente",
  verification_data_unavailable:
    "Não foi possível carregar os dados da verificação. Tente novamente mais tarde.",
  verification_copy_link_unavailable:
    "Um novo link foi gerado, mas não foi possível copiá-lo para a área de transferência. Tente novamente em um navegador compatível.",
  security_pin_status_badge: "PIN ATIVO",
  security_pin_active_title: "Sua conta está protegida com um PIN de segurança",
  security_pin_active_sub:
    "Vamos pedi-lo em ações sensíveis. Para mais segurança, mude para o app autenticador.",
  security_pin_change: "Alterar PIN",
  security_pin_remove: "Remover PIN",
  security_pin_locked_title: "Seu PIN está bloqueado",
  security_pin_locked_temporary:
    "Muitas tentativas erradas. Ele será desbloqueado em {{time}}, ou crie um novo agora.",
  security_pin_locked_reset:
    "Muitas tentativas erradas. Crie um novo PIN com sua senha para continuar usando.",
  security_pin_locked_action: "Criar novo PIN",
  security_totp_replaces_pin:
    "O app autenticador protege suas ações sensíveis e substitui o PIN de segurança.",
  security_totp_will_replace_pin:
    "Quando você verificar o código, o app substitui seu PIN: a partir daí vamos pedir o código do app.",
  security_upgrade_pick: "Quer mais segurança?",
  security_method_totp_sub_upgrade: "Mais seguro que o PIN: o código fica no seu celular e muda a cada 30 s.",
  security_method_tag_recommended_secure: "RECOMENDADO · MAIS SEGURO",
  security_method_pin_name: "PIN de segurança",
  security_method_pin_sub:
    "Seis dígitos que você escolhe. Pronto em um minuto, embora menos seguro que o app.",
  security_method_pin_sub_active: "É o seu método atual.",
  security_method_tag_active: "ATIVO",
  security_method_tag_fastest: "MAIS RÁPIDO",
  security_methods_compare_note:
    "O app autenticador é a opção mais segura: o código muda a cada 30 segundos e fica só no seu celular. O PIN é mais rápido de configurar; se começar com ele, você pode mudar para o app quando quiser.",
  security_pin_setup_title: "Criar PIN de segurança",
  security_pin_created_toast: "Seu PIN de segurança está ativo",
  security_pin_changed_toast: "Seu novo PIN foi salvo",
  security_pin_removed_toast: "Você removeu seu PIN de segurança",
  security_pin_remove_title: "Remover seu PIN de segurança?",
  security_pin_remove_body:
    "Sem PIN nem app autenticador, você não poderá criar cartões, ver seus dados nem movimentar dinheiro até configurar um dos dois.",
  security_pin_remove_confirm: "Remover PIN",
  security_pin_remove_cancel: "Cancelar",
  security_totp_password_intro:
    "Primeiro confirme que é você: digite sua senha e geramos o código QR para o seu app.",
  security_totp_password_submit: "Gerar código QR",
  security_totp_password_required: "Digite sua senha.",
  security_totp_locked_title: "Confirmação em pausa",
  security_totp_locked:
    "Houve 5 códigos incorretos seguidos. Você poderá confirmar ações novamente em {{time}}.",
  security_email_backup_eyebrow: "Plano B",
  security_email_backup_title: "Backup por e-mail",
  security_email_backup_sub_pin_on:
    "Ativado: se você esquecer o seu PIN ou ele estiver bloqueado, enviamos um código para o seu e-mail para confirmar a ação.",
  security_email_backup_sub_pin_off:
    "Desativado: se você esquecer o seu PIN, terá que criar um novo com a sua senha antes de continuar.",
  security_email_backup_sub_totp_off:
    "É um pouco menos seguro do que usar só o app: quem entrar no seu e-mail também poderia confirmar ações. Ative só se quiser um plano B.",
  security_email_backup_sub_totp_on:
    "Ativado: se você não estiver com o celular à mão, enviamos um código para o seu e-mail. Quem entrar no seu e-mail também poderia confirmar ações.",
  security_email_backup_sub_none:
    "Fica disponível quando você escolher o app autenticador ou um PIN: é o plano B desse método, não um método por si só.",
  security_email_backup_destination: "Os códigos chegam em {{email}}",
  security_email_backup_tag_on: "Ativado",
  security_email_backup_tag_off: "Desativado",
  security_email_backup_tag_unavailable: "Ainda não disponível",
  security_email_backup_switch_label: "Ativar ou desativar o backup por e-mail",
  security_email_backup_enable_title: "Ativar backup por e-mail",
  security_email_backup_disable_title: "Desativar backup por e-mail",
  security_email_backup_enable_body_pin:
    "Se algum dia você esquecer o seu PIN ou ele for bloqueado, poderá pedir um código em {{email}} para confirmar a ação.",
  security_email_backup_enable_body_totp:
    "Se você não estiver com o celular à mão, poderá pedir um código em {{email}}. Lembre-se de que quem entrar no seu e-mail também poderia confirmar ações.",
  security_email_backup_disable_body:
    "Você só poderá confirmar ações com o seu método principal. Se perdê-lo, terá que recuperá-lo antes de continuar.",
  security_email_backup_password_intro: "Confirme com a sua senha para salvar a alteração.",
  security_email_backup_cancel: "Cancelar",
  security_email_backup_enable_confirm: "Ativar backup",
  security_email_backup_disable_confirm: "Desativar backup",
  security_email_backup_enabled_toast: "Pronto: o backup por e-mail está ativado.",
  security_email_backup_disabled_toast: "Pronto: o backup por e-mail está desativado.",
  security_guide_title: "Qual eu escolho?",
  security_guide_totp_label: "App autenticador",
  security_guide_totp: "O mais seguro: um código novo no seu celular a cada 30 segundos.",
  security_guide_pin_label: "PIN de segurança",
  security_guide_pin: "O mais rápido: seis dígitos que você escolhe, prontos em um minuto.",
  security_guide_email_label: "Backup por e-mail",
  security_guide_email:
    "O plano B: um código no seu e-mail quando você não está com o PIN ou o celular à mão.",
  security_method_pin_email_note: "Inclui backup por e-mail",
  security_method_totp_email_note: "Backup por e-mail opcional",

  // Access — permission board (areas, shortcuts, actions)
  access_area_money: "Dinheiro e pagamentos",
  access_area_money_hint: "Carteiras, cobranças, pagamentos, conversões e pagamentos em lote.",
  access_area_cards: "Cartões",
  access_area_cards_hint: "Cartões, recargas e movimentações de saldo entre cartões.",
  access_area_clients: "Clientes",
  access_area_clients_hint: "Os clientes da sua organização e suas contas bancárias.",
  access_area_organization: "Organização e verificação",
  access_area_organization_hint: "Os dados da organização, suas contas e a verificação de identidade (KYC).",
  access_area_team: "Equipe e acessos",
  access_area_team_hint: "As pessoas da conta, seus papéis e as políticas de acesso.",
  access_area_developers: "Desenvolvedores",
  access_area_developers_hint: "API keys e webhooks para integrar com a Coloca.",
  access_area_fees: "Comissões",
  access_area_fees_hint: "As comissões e sua configuração.",
  access_area_operations: "Operação interna",
  access_area_operations_hint:
    "Ferramentas de backoffice da Coloca: confirmações, auditoria, cotações e notas.",
  access_area_count_aria: "{{granted}} de {{total}} permissões",
  access_preset_label: "Rápido:",
  access_preset_none: "Nada",
  access_preset_read: "Só ver",
  access_preset_readWrite: "Ver e editar",
  access_preset_all: "Tudo",
  access_preset_sensitive_note:
    "As permissões marcadas como Sensível ficam fora desses atalhos: ative-as uma a uma.",
  access_module_sensitive: "Sensível",
  access_level_read: "Ver",
  access_level_write: "Editar",
  access_level_delete: "Excluir",
  access_level_read_hint: "Consultar as informações",
  access_level_write_hint: "Criar e modificar",
  access_level_delete_hint: "Apagar ou anular",
  access_cell_covered: "Já concedido por outro papel ou política selecionada",
  access_cell_covered_by_role_one:
    "Concedido por {{roles, list}}: para removê-lo, desmarque esse papel em {{section}}",
  access_cell_covered_by_role:
    "Concedido por {{roles, list}}: para removê-lo, desmarque esses papéis em {{section}}",
  access_cell_covered_by_role_split_one:
    "Concedido por {{roles, list}}: se removê-lo, esse papel é substituído pelas demais permissões, uma a uma",
  access_cell_covered_by_role_split:
    "Concedido por {{roles, list}}: se removê-lo, esses papéis são substituídos pelas demais permissões, uma a uma",
  access_cell_denied: "Bloqueado por uma política que nega",
  access_cell_unavailable: "Não há uma permissão individual para esta ação",
  access_cell_risky: "Ação de alto impacto",
  access_board_search_placeholder: "Buscar permissão, ex. cartões",
  access_board_no_matches: "Nenhuma permissão corresponde à busca.",
  access_board_covered_legend:
    "Já concedido por um papel em {{section}}: para removê-lo, desmarque esse papel.",
  access_board_covered_legend_split:
    "Já concedido por um papel em {{section}}. Você ainda pode removê-lo: esse papel é substituído pelas demais permissões, uma a uma, e o resto fica igual.",
  access_split_title_one: "Remover «{{permission}}»?",
  access_split_title: "Remover {{count}} permissões?",
  access_split_what_one: "esta permissão",
  access_split_what: "estas {{count}} permissões",
  access_split_description_one:
    "{{roles, list}} reúne várias permissões. Para remover {{what}}, esse papel é substituído pelas demais permissões, uma a uma, e {{name}} mantém todo o resto.",
  access_split_description:
    "{{roles, list}} reúnem várias permissões. Para remover {{what}}, esses papéis são substituídos pelas demais permissões, uma a uma, e {{name}} mantém todo o resto.",
  access_split_lost_one: "Ela não existe como permissão individual, então também se perde: {{cells, list}}.",
  access_split_lost: "Elas não existem como permissões individuais, então também se perdem: {{cells, list}}.",
  access_split_confirm_one: "Remover permissão",
  access_split_confirm: "Remover permissões",
  access_split_cancel: "Cancelar",
  access_split_blocked:
    "Não dá para remover aqui: o papel que dá esse acesso também bloqueia permissões. Desmarque-o em {{section}}.",
  access_effective_idle_one: "Mais 1 módulo sem acesso",
  access_effective_idle: "Mais {{count}} módulos sem acesso",
  access_effective_no_access: "Sem acesso a: {{areas}}.",
  access_role_permissions_label: "Permissões do papel",
  access_role_permissions_hint:
    "Escolha o que o papel pode fazer em cada área: use um atalho ou marque ação por ação.",
  access_role_other_policies: "Outras políticas",
  access_role_other_policies_hint:
    "Políticas que combinam várias permissões, ou que bloqueiam uma mesmo quando outra a concede.",
  access_drawer_combined_roles: "Papéis combinados",
  access_drawer_combined_hint: "Cada um concede várias permissões de uma vez.",
  access_drawer_permissions_label: "Permissões por área",
  access_drawer_permissions_hint: "Cada caixa atribui o papel dessa permissão e é salva na hora.",

  // Access — Settings roles and policies lists by area
  access_catalog_search_placeholder: "Buscar por nome ou permissão, ex. cartões",
  access_catalog_no_matches: "Nada corresponde à busca.",
  access_roles_group_combined: "Papéis combinados",
  access_roles_group_combined_note: "Papéis da Coloca que concedem várias permissões de uma vez.",
  access_roles_group_basic: "Papéis básicos por área",
  access_roles_group_basic_note: "Um papel por permissão. Toque numa ação para ver o papel e quem o tem.",
  access_policies_group_basic: "Políticas básicas por área",
  access_policies_group_basic_note:
    "Uma política por permissão, para montar papéis. Toque numa ação para vê-la.",
};
